function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientTransform: "matrix(1 0 0 -1 -59.766112 454.565432)",
  gradientUnits: "userSpaceOnUse",
  x1: 256,
  x2: 256,
  y1: 460,
  y2: 32
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00efd1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00acea"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "edit",
  d: "m342.402344 14.621094c-19.542969-19.496094-51.171875-19.496094-70.710938 0l-237.089844 237.089844c-2.886718 2.886718-3.726562 7.242187-2.121093 11l-32.050781 117.820312c-.945313 3.472656.050781 7.1875 2.605468 9.722656 2.558594 2.535156 6.28125 3.5 9.746094 2.527344l116.933594-32.867188c3.746094 1.574219 8.070312.722657 10.941406-2.148437l237.089844-237.089844c19.523437-19.527343 19.523437-51.183593 0-70.710937zm-84.601563 42.167968 77.351563 78.195313-201.570313 201.566406-77.769531-77.769531zm-209.246093 223.019532 64.121093 64.117187-88.316406 24.828125zm315.046874-173.273438-14.304687 14.304688-77.351563-78.191406 13.886719-13.882813c11.726563-11.699219 30.703125-11.699219 42.429688 0l35.34375 35.34375c11.695312 11.722656 11.695312 30.703125-.003907 42.425781zm0 0",
  fill: "url(#a)"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "393pt",
    viewBox: "-1 0 393 393.15442",
    width: "393pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.431a34d3.svg";
export { ForwardRef as ReactComponent };